import { INITIALIZE_APP } from '../constants';

const initialState = {
    env: {},
    featureFlags: {
        newPostponedEventPolicy: false,
    },
    helpLinks: {
        canIGetARefund: '',
        howToContactTheEventOrganizer: '',
        whereAreMyTickets: '',
        whereIsMyRefund: '',
    },
    recaptcha2PublicKey: '',
    hideCaptcha: false,
    user: {},
};

const initialData = (state = initialState, action) => {
    if (action.type === INITIALIZE_APP) {
        return { ...state, ...action.payload };
    }

    return state;
};

export default initialData;
